(() => {
  'use strict';
  if (window.NiralaProductGalleryInitialized) return;
  window.NiralaProductGalleryInitialized = true;
  const imageIdentity = (src) => {
    try { const url = new URL(src, window.location.href); return url.origin + url.pathname; }
    catch (_) { return String(src || ''); }
  };
  function initialize(root = document) {
    root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady) return;
      const frame = gallery.querySelector('[data-gallery-frame]');
      const image = gallery.querySelector('[data-product-image]');
      let images;
      try { images = JSON.parse(gallery.querySelector('[data-gallery-images]')?.textContent || '[]'); }
      catch (_) { return; }
      if (!frame || !image || !Array.isArray(images) || images.length < 2 || images.some(item => !item || typeof item.src !== 'string' || !item.src)) return;
      gallery.dataset.galleryReady = 'true';
      const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
      const status = gallery.querySelector('[data-gallery-status]');
      const section = gallery.closest('[data-product-section]');
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      const swipeEnabled = gallery.dataset.gallerySwipe !== 'false' || gallery.dataset.galleryNavigation === 'swipe';
      let current = Math.max(0, images.findIndex(item => imageIdentity(item.src) === imageIdentity(image.src)));
      let pointer = null;
      const show = (index, animate = true) => {
        if (!Number.isInteger(index)) return;
        current = ((index % images.length) + images.length) % images.length;
        const item = images[current];
        // Keep Shopify's responsive candidates on the initial photo. Clear
        // them only when navigating so a previous photo cannot win srcset.
        if (animate || imageIdentity(image.src) !== imageIdentity(item.src)) {
          image.removeAttribute('srcset');
          image.src = item.src;
        }
        image.alt = item.alt || section?.dataset.productTitle || '';
        // Preserve the initial frame ratio so variant swaps do not move the layout.
        gallery.dataset.galleryIndex = String(current);
        buttons.forEach(button => {
          const selected = Number(button.dataset.galleryIndex) === current;
          button.setAttribute(button.tagName === 'A' ? 'aria-current' : 'aria-pressed', String(selected));
        });
        if (status) status.textContent = item.label || `${current + 1} / ${images.length}`;
        if (animate && !reducedMotion?.matches && typeof image.animate === 'function') {
          image.animate([{ opacity: .65 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
        }
      };
      gallery.querySelectorAll('[data-gallery-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => show(current + Number(button.dataset.galleryStep)));
      });
      const dots = gallery.querySelector('[data-gallery-dots]');
      if (dots) dots.hidden = false;
      buttons.forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        show(Number(button.dataset.galleryIndex));
      }));
      frame.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = current + 1;
        else if (event.key === 'ArrowLeft') next = current - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = images.length - 1;
        else return;
        event.preventDefault();
        show(next);
      });
      if (swipeEnabled) {
        frame.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || event.isPrimary === false || event.target.closest('button, a')) return;
          pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
          frame.setPointerCapture?.(event.pointerId);
        });
        frame.addEventListener('pointerup', event => {
          if (!pointer || event.pointerId !== pointer.id) return;
          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;
          pointer = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx < 0 ? 1 : -1));
        });
        frame.addEventListener('pointercancel', () => { pointer = null; });
      }
      section?.addEventListener('nirala:variant-change', event => {
        const src = event.detail?.variant?.image;
        if (!src) return;
        const index = images.findIndex(item => imageIdentity(item.variantSrc || item.src) === imageIdentity(src));
        if (index >= 0 && index !== current) show(index);
      });
      show(current, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
